// Axios instance preconfigured with the admin Bearer token + automatic 401
// redirect to /login. All admin pages should import this instead of axios
// directly so they get the auth header for free.
//
// `backendURL` is the default export from ../config (matches klonit-dashboard).
import axios from 'axios';
import backendURL, { STORAGE_TOKEN_KEY, STORAGE_EMAIL_KEY } from '../config';

const instance = axios.create({
    baseURL: backendURL,
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
});

instance.interceptors.request.use((cfg) => {
    const token = localStorage.getItem(STORAGE_TOKEN_KEY);
    if (token) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});

instance.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err.response?.status;
        if (status === 401) {
            localStorage.removeItem(STORAGE_TOKEN_KEY);
            localStorage.removeItem(STORAGE_EMAIL_KEY);
            // Avoid an infinite loop if the 401 happened on /admin/auth/login itself.
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(err);
    },
);

export default instance;
